module.exports = __webpack_public_path__ + "static/media/wxlogin_logo.05cc53e3.png";